const userInfo = localStorage.getItem("userInfo") ? JSON.parse(localStorage.getItem("userInfo")) : {};
const isLogin = !!localStorage.getItem("loginState");
const lang = localStorage.getItem("lang") || "pt-br";
const isPushWhatsApp = localStorage.getItem("isPushWhatsApp") || "";

export default function () {
  return {
    lang,
    userInfo,
    isLogin, // 登录状态
    showLogin: false, // pc登录弹框是否展示
    loginTo: "",
    showRegister: false, // pc注册弹框是否展示
    redirectPath: null,
    isPushWhatsApp: isPushWhatsApp && JSON.parse(isPushWhatsApp),
  };
}
